export const setTime = (date: Date, dateFrom: Date) => {
  date.setHours(dateFrom.getHours());
  date.setMinutes(dateFrom.getMinutes());
  date.setSeconds(0);
  date.setMilliseconds(0);
  return date;
};
